import { Form } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'

import MoneyField from 'modules/core/components/MoneyField'
import i18n from 'modules/core/lib/i18n'

import BudgetExceededOptionSelector, {
  BudgetExceededOptionResultType,
} from '../../../BudgetExceededOptionSelector'

interface FormValues {
  limitPerEmployee?: string
  newBudgetLimit?: number
}

interface AllocationPerEmployeeFormProps {
  currency: string
  budgetLimit: number
  totalAllocatedAmountCents: number
  allocationIds: number[]
  displayExtraSection: boolean
  setDisplayExtraSection: (display: boolean) => void
  form: FormikProps<FormValues>
  setSelectorResult: (value: BudgetExceededOptionResultType) => void
}

const AllocationPerEmployeeForm = ({
  currency,
  budgetLimit,
  form,
  allocationIds,
  totalAllocatedAmountCents,
  setDisplayExtraSection,
  displayExtraSection,
  setSelectorResult,
}: AllocationPerEmployeeFormProps) => {
  const handleOnChange = (value: string) => {
    form.setValues({
      ...form.values,
      limitPerEmployee: value,
    })
    setSelectorResult({
      increaseLimit: 0,
      tryAnotherAllocation: 0,
      type: '',
    })
  }

  const setAllocationValue = (value: number) => {
    form.setValues({
      ...form.values,
      limitPerEmployee: value.toString(),
    })
  }

  return (
    <Form padding="s0" aria-label={i18n.t('budgets.detail.allocation_per_employee_modal.title')}>
      <MoneyField
        currency={currency}
        label={i18n.t('budgets.detail.allocation_per_employee_modal.limit_per_employee')}
        value={form.values.limitPerEmployee}
        onChange={handleOnChange}
        placeholder={'0'}
        error={form.errors.limitPerEmployee}
      />

      <BudgetExceededOptionSelector
        currency={currency}
        budgetLimit={budgetLimit}
        newAllocationValueCents={Number(form.values.limitPerEmployee) * 100}
        numberOfEmployees={allocationIds.length}
        totalAllocatedAmountCents={totalAllocatedAmountCents}
        setVisible={setDisplayExtraSection}
        visible={displayExtraSection}
        setSelectorResult={setSelectorResult}
        setAllocationValue={setAllocationValue}
        clearErrors={() => form.setErrors({ limitPerEmployee: undefined })}
      />
    </Form>
  )
}

export default AllocationPerEmployeeForm
